<div class="mat-dialog-header">
    <h4>Assign Ticket</h4>
    <span><strong>{{ ticket_name | titlecase }}</strong></span><br>

    <span *ngIf="tic_category">Category: {{ tic_category }}</span><br *ngIf="tic_category">
    <span>Booked Tickets: {{ allowed_person }}</span>
</div>
<mat-dialog-content>
    <!-- Modal Header with Category and Ticket Name -->

    <!-- Form for ticket assignment -->
    <form (ngSubmit)="Assign_Ticket()">
        <div class="ticket-list">
            <div *ngIf="!alloted_ticket">
                <mat-list>
                    <mat-list-item *ngFor="let data of unassigned_tickets_data">
                        <mat-checkbox [value]="data" (change)="onCheckboxChange($event, data)"
                            [disabled]="selectedTickets >= allowed_person && !isChecked(data)">
                            Row - {{ data.row }}, Seat No - {{ data.seat_no }}
                        </mat-checkbox>
                    </mat-list-item>
                </mat-list>
            </div>

            <!-- If tickets are already assigned, show assigned ticket alert -->
            <div *ngIf="alloted_ticket">
                <div class="ticket-assigned-alert">
                    <h4 class="ticket-assigned-header">
                        <mat-icon class="ticket-icon">check_circle_outline</mat-icon>
                        Ticket Already Assigned
                    </h4>
                    <div *ngFor="let data of unassigned_tickets_data" class="ticket-info">
                        <div class="ticket-details">
                            <span class="label">Row:</span> {{ data.row }}
                            <span class="label">Seat No:</span> {{ data.seat_no }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Dialog Action Buttons (Cancel and Assign/Update) -->
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button type="submit" color="primary" (click)="Assign_Ticket()" *ngIf="!alloted_ticket">Assign
    </button>
</mat-dialog-actions>